export function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 border-b border-[#E0E0D8] pb-8 mb-10"
    >
      <div>
        {eyebrow && (
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF3E00] mb-3">
            {eyebrow}
          </p>
        )}
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter leading-none">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-[#555] mt-4 max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3 shrink-0">{actions}</div>}
    </div>
  );
}

export function SectionLabel({ children }) {
  return (
    <p className="text-xs font-mono uppercase tracking-[0.15em] text-[#555] mb-3">
      {children}
    </p>
  );
}

export function StatBlock({ label, value, sublabel, testid }) {
  return (
    <div
      data-testid={testid}
      className="border border-[#E0E0D8] bg-white p-6 hover:border-[#0A0A0A] transition-colors"
    >
      <p className="text-xs font-mono uppercase tracking-[0.15em] text-[#555]">{label}</p>
      <p className="font-mono text-3xl tracking-tighter text-[#0A0A0A] mt-2">{value}</p>
      {sublabel && <p className="text-xs text-[#888] mt-2">{sublabel}</p>}
    </div>
  );
}
